import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { LatestMessageAccess } from 'find-and-filter-data/view-members-schema/public';
import styled from 'styled-components';
import { stripZeroWidthCharacters } from 'svh-workspace-ui-lib/preview-card/public/operators';
import { AttachmentType } from 'svh-workspace-ui-lib/preview-card/public/components/AttachmentType';
import InboxSLAOnboardingModal from 'svh-workspace-ui-lib/preview-card/public/components/InboxSLAOnboardingModal';
import { PreviewCardContentWrapper, PreviewCardContentTextWrapper, PreviewCardContentHeaderWrapper } from './PreviewCardStyles';
import ResponseStatusIcon from 'svh-workspace-ui-lib/preview-card/public/components/ResponseStatusIcon';
import PreviewCardSLAIcon from 'svh-workspace-ui-lib/preview-card/public/components/PreviewCardSLAIcon';
import LineClamp from '../../common/components/LineClamp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublishFailedError = () => /*#__PURE__*/_jsxs(Small, {
  use: "error",
  children: [/*#__PURE__*/_jsx(UIIcon, {
    className: "m-right-1",
    name: "warning",
    size: "xxs"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.preview-card.PUBLISH_FAILED.message"
  })]
});
PublishFailedError.displayName = 'PublishFailedError';
export const SLAIconWrapper = styled.div.withConfig({
  displayName: "PreviewCardContent__SLAIconWrapper",
  componentId: "sc-1giaw4p-0"
})(["position:absolute;right:12px;bottom:12px;"]);
const PreviewCardContent = ({
  forwarded,
  isComment,
  latestMessageAccess = LatestMessageAccess.ACCESS,
  isUnread,
  hasNoConversation,
  publishFailed,
  repliedTo,
  slaStatus,
  secondaryHeader,
  isNameHeader,
  isUnknownContact,
  textPreview,
  showInboxSLATour,
  onInboxSLATourOpen,
  onInboxSLATourClose,
  attachmentTypes,
  shouldDisableSLA
}) => {
  if (publishFailed) {
    return /*#__PURE__*/_jsx(PreviewCardContentWrapper, {
      children: /*#__PURE__*/_jsx(PublishFailedError, {
        "data-test-id": "publish-failed"
      })
    });
  }
  return /*#__PURE__*/_jsxs(PreviewCardContentWrapper, {
    "data-test-id": "member-context",
    children: [secondaryHeader && /*#__PURE__*/_jsx("div", {
      className: "flex-row width-100",
      children: /*#__PURE__*/_jsx(PreviewCardContentHeaderWrapper, {
        isUnread: isUnread,
        isUnknownContact: isNameHeader && isUnknownContact,
        children: /*#__PURE__*/_jsx(LineClamp, {
          maxLines: 1,
          children: /*#__PURE__*/_jsx(UITruncateString, {
            tooltip: !isNameHeader,
            children: secondaryHeader
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-row width-100",
      children: /*#__PURE__*/_jsx(PreviewCardContentTextWrapper, {
        isComment: isComment,
        isUnread: isUnread,
        hasSLA: !!slaStatus,
        hasNoConversation: hasNoConversation,
        "data-test-id": "member-preview",
        children: /*#__PURE__*/_jsx(LineClamp, {
          maxLines: secondaryHeader ? 1 : 2,
          children: /*#__PURE__*/_jsxs(UITruncateString, {
            children: [latestMessageAccess === LatestMessageAccess.ACCESS && /*#__PURE__*/_jsx(ResponseStatusIcon, {
              forwarded: forwarded,
              repliedTo: repliedTo
            }), latestMessageAccess === LatestMessageAccess.ACCESS && textPreview && /*#__PURE__*/_jsx("span", {
              children: stripZeroWidthCharacters(textPreview)
            }), latestMessageAccess === LatestMessageAccess.ACCESS && !textPreview && attachmentTypes && /*#__PURE__*/_jsx(AttachmentType, {
              attachmentTypes: attachmentTypes,
              repliedTo: repliedTo
            }), latestMessageAccess === LatestMessageAccess.NO_ACCESS && /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.preview-card.hide-message-preview"
            })]
          })
        })
      })
    }), !shouldDisableSLA && /*#__PURE__*/_jsx(SLAIconWrapper, {
      children: showInboxSLATour ? /*#__PURE__*/_jsx(InboxSLAOnboardingModal, {
        onInboxSLATourOpen: onInboxSLATourOpen,
        onInboxSLATourClose: onInboxSLATourClose,
        children: /*#__PURE__*/_jsx(PreviewCardSLAIcon, {
          status: slaStatus
        })
      }) : /*#__PURE__*/_jsx(PreviewCardSLAIcon, {
        status: slaStatus
      })
    })]
  });
};
PreviewCardContent.displayName = 'PreviewCardContent';
export default PreviewCardContent;